import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

// Cores usando a paleta primária (#00B4C0) e complementares
const COLORS = ['#00B4C0', '#009F94', '#93C462', '#f59e0b', '#8b5cf6', '#ec4899'];

const ChannelDistribution = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
        <h3 className="text-lg font-semibold mb-4 text-gray-800">Distribuição por Canal</h3>
        <p className="text-gray-500">Nenhum dado disponível</p>
      </div>
    );
  }

  const chartData = data.map((item) => ({
    name: item.channel_name || item.channel_type,
    value: parseFloat(item.percentage),
    count: parseInt(item.total_conversations),
  }));

  return (
    <div className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
      <h3 className="text-lg font-semibold mb-4 text-gray-800">Distribuição por Canal</h3>

      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name, props) => [
              `${value}% (${props.payload.count} conversas)`,
              props.payload.name
            ]}
            contentStyle={{
              backgroundColor: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>

      <div className="mt-4 grid grid-cols-2 gap-3">
        {data.map((item, index) => (
          <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-primary-50 transition-colors">
            <div className="flex items-center">
              <div
                className="w-3 h-3 rounded-full mr-2"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
              />
              <span className="text-sm font-medium text-gray-700">{item.channel_name}</span>
            </div>
            <span className="text-sm font-semibold text-gray-800">{item.total_conversations}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChannelDistribution;
